module.exports = __webpack_public_path__ + "img/banner-mobile.579ab34b.png";